import { apiBffMobileV1PaymentMethods } from './api'

export const getPaymentMethodsByVendor = async (vendorId: string): Promise<string[]> => {
  const response = await apiBffMobileV1PaymentMethods.get(`/forms?vendorIds=${vendorId}`)

  return response.data[0]['whitelist']
}
